import React, { useState, useEffect } from 'react';
import { formatDate } from '../../../helpers/formatDate';
import { Button, Col, Modal, Row } from 'reactstrap';
import PromotionRedemptionDetails from './PromotionRedemptionDetails';
import { If } from 'react-if';
const RedemptionItem = ({ redemption }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const appliedCoupons = redemption?.response?.summary?.discountSummary
    ?.map((discount) => discount?.couponCode)
    ?.filter((couponCode) => couponCode != null);

  return (
    <>
      <div className="border-bottom p-3">
        <Row>
          {/* Left Section */}
          <Col md={8} className="border-end pe-4 d-flex gap-3">
            <div className="icon-container">
              <span className="d-flex justify-content-center align-items-center bg-dark-subtle p-3 rounded-circle text-info fs-44 opacity-25">
                <i className="bx bxs-discount"></i>
              </span>
            </div>
            <div className="details-container flex-grow-1">
              <div className="d-flex flex-column gap-1">
                <p className="m-0 fs-13 text-muted">
                  LC Trans. ID:{' '}
                  <strong className="text-dark">#{redemption?._id}</strong>
                </p>
                <p className="m-0 fs-11 text-muted">
                  Ref:{' '}
                  <strong className="text-dark">
                    {redemption?.transactionRef}
                  </strong>
                </p>
                <p className="m-0 fs-11 text-muted">
                  Redeemed By:{' '}
                  <strong className="text-dark">
                    {' '}
                    {redemption?.user?._em}
                  </strong>
                </p>
                <If condition={redemption?.status === 'canceled'}>
                  <p className="m-0 fs-11 text-muted">
                    Previous Status:{' '}
                    <strong className="text-dark">
                      {redemption?.previousStatus}
                    </strong>
                  </p>
                </If>
                <p className="m-0 fs-11 text-muted">
                  Status:{' '}
                  <strong className="text-dark">{redemption?.status}</strong>
                </p>
                <If condition={redemption?.status === 'canceled'}>
                  <p className="m-0 fs-11 text-muted">
                    Reason:{' '}
                    <strong className="text-dark">
                      {redemption?.voidReason}
                    </strong>
                  </p>
                </If>
                <div className="d-flex flex-wrap align-items-center gap-1">
                  <p className="m-0 fs-11 text-muted">
                    Hold At:{' '}
                    <strong className="text-dark">
                      {redemption?.holdAt
                        ? formatDate(redemption?.holdAt)
                        : '-'}
                    </strong>
                  </p>
                  <span className="fs-12 text-muted">|</span>
                  <p className="m-0 fs-11 text-muted">
                    Confirmed At:{' '}
                    <strong className="text-dark">
                      {redemption?.confirmedAt
                        ? formatDate(redemption?.confirmedAt)
                        : '-'}
                    </strong>
                  </p>
                </div>

                <p className="m-0 fs-11 text-muted">
                  Applied Coupons:{' '}
                  <strong className="text-dark">
                    {appliedCoupons?.join(',')}
                  </strong>
                </p>
              </div>
            </div>
          </Col>
          {/* Right Section */}
          <Col
            md={4}
            className="d-flex align-items-center justify-content-between"
          >
            {/* Summary Section */}
            <div className="summary-container d-flex gap-1 flex-column">
              <p className="m-0 fs-11 text-muted">
                Sub Total:{' '}
                <strong className="text-dark fs-13">
                  {`AED ${redemption?.response?.summary?.subTotal?.toFixed(
                    2
                  )}` || '-'}
                </strong>
              </p>
              <p className="m-0 fs-11 text-muted">
                Total Discount:{' '}
                <strong className="text-dark fs-13">
                  {`AED ${redemption?.response?.summary?.totalDiscount?.toFixed(
                    2
                  )}` || '-'}
                </strong>
              </p>
              <p className="m-0 fs-11 text-muted">
                Grand Total:{' '}
                <strong className="text-dark fs-13">
                  {`AED ${redemption?.response?.summary?.finalValue?.toFixed(
                    2
                  )}` || '-'}
                </strong>
              </p>
              {redemption?.response?.summary?.refundSummary?.extraPayment && (
                <p className="m-0 fs-11 text-muted">
                  Extra Payment:{' '}
                  <strong className="text-dark fs-13">
                    {`AED ${redemption?.response?.summary?.refundSummary?.extraPayment?.toFixed(
                      2
                    )}`}
                  </strong>
                </p>
              )}
              {redemption?.response?.summary?.refundSummary
                ?.finalRefundableAmount && (
                <p className="m-0 fs-11 text-muted">
                  Refundable Amount:{' '}
                  <strong className="text-dark fs-13">
                    {`AED ${redemption?.response?.summary?.refundSummary?.finalRefundableAmount?.toFixed(
                      2
                    )}`}
                  </strong>
                </p>
              )}
            </div>

            {/* Button Section */}
            <div className="button-group d-flex flex-row gap-2">
              <Button
                size="sm"
                outline
                color="info"
                onClick={() => setIsOpenModal(true)}
              >
                View Details
              </Button>

              <Button size="sm" outline color="danger" className="me-2">
                Cancel
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      <Modal isOpen={isOpenModal} toggle={closeModal} centered size="xl">
        <div className="modal-header">
          <h5 className="modal-title">Redemption Details</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setIsOpenModal(false);
            }}
          ></button>
        </div>
        <div className="modal-body">
          <PromotionRedemptionDetails redemption={redemption} />
        </div>
      </Modal>
    </>
  );
};

export default RedemptionItem;
